import React, { useRef } from 'react';
import { FuelIcon, MileageIcon, RalentiIcon, SpeedViolationIcon, StoppedTimeIcon, WorkingTimeIcon } from '../../../assets/icons';
import { useDrag, useDrop } from 'react-dnd';
import './menuItem.css';


const MenuItem = ({ item, index, draggedIndex, setDraggedIndex, moveMenuItem, onCloseMenu }) => {
  const ref = useRef(null);

  const icons = {
    'Kilometraje': <MileageIcon />,
    'Tiempo detenido': <StoppedTimeIcon />,
    'Exceso de velocidad': <SpeedViolationIcon />,
    'Ralentí': <RalentiIcon />,
    'Combustible': <FuelIcon />,
    'Tiempo de trabajo': <WorkingTimeIcon />,
  };

  const [, drop] = useDrop({
    accept: 'MENU_ITEM',
    hover: (draggedItem) => {
      if (draggedItem.index !== index && draggedIndex !== index) {
        setDraggedIndex(index); // Actualiza el índice de destino al pasar por encima
      }
    },
    drop: (draggedItem) => {
      if (draggedItem.index !== index) {
        moveMenuItem(draggedItem.index, index); // Reordena solo al soltar (drop)
        setDraggedIndex(null); // Limpia el índice arrastrado después de soltar
      }
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: 'MENU_ITEM',
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    end: () => {
      setDraggedIndex(null); // Limpia el índice cuando se termina de arrastrar
    },
  });

  drag(drop(ref));

  // Función para hacer scroll a la sección correspondiente
  const scrollToSection = () => {
    const section = document.querySelector(item.anchor);
    if (section) {
      onCloseMenu();
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div ref={ref} className={`tab_container ${draggedIndex === index ? 'drag-preview' : ''}`} title={item.name} style={{ opacity: isDragging ? 0.5 : 1 }} >
      <a href={item.anchor} className='tab_container_ref' onClick={scrollToSection}>
        {icons[item.name]}
        <span className='tab_text'>{item.name}</span>
      </a>
    </div>
  );
};

export default MenuItem;
